export const features = [
    {
        id: 1,
        image: require('./Features/status-up.svg').default,
        text: 'Predictive analytics for accurate risk assessment'
    },
    {
        id: 2,
        image: require('./Features/health.svg').default,
        text: 'Compliance management for regulatory adherence'
    },
    {
        id: 3,
        image: require('./Features/home-hashtag.svg').default,
        text: 'Historical loan performance analysis for future defaults'
    },
    {
        id: 4,
        image: require('./Features/chart.svg').default,
        text: 'Data integration for comprehensive financial history.'
    }
]